import { Icon } from 'leaflet'
import React, { useEffect, useState } from 'react'

import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'

import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import Ruta from '../models/Ruta'
import { getRutas } from '../services/RutasService'

// import "leaflet/dist/leaflet.css";
import './EstilosViews.scss';

type Props = {}

const Rutas = (props: Props) => {

    const tituloSeccion: string = "Rutas"

    const descricionSeccion: string = "Desde aquí te ofrecemos unas pocas rutas para poder describir nuestro privilegiado entorno."

    const [rutas, setRutas] = useState<Ruta[]>([]);

    const icono: Icon = new Icon({iconUrl: "/img/leaflet/marker-icon.png"})

    const position = {
        lat: 40.429444,
        lng: -1.711944
    }

    useEffect(() => {
        setRutas(getRutas())
    }, []);

    const ResizeMap = () => {
        const map = useMap();
        map.invalidateSize();
        return null;
      };


    const pintarMapa = () => {
        return <div className='leaflet-container'>
            <MapContainer center={position} zoom={13} scrollWheelZoom={false}        >
                <ResizeMap/>
            <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}
            icon={icono}>
            <Popup>
                A pretty CSS3 popup. <br /> Easily customizable.
            </Popup>
            </Marker>
        </MapContainer>
      </div>
    }

    const pintarTipoActividad = () => {
        return rutas.map((ruta: Ruta, index: number) => {
            return "";
        })
    }

    const generarSeccionRutas = () => {

        

        return (
            <section className="page-section seccionBlanca seccionRutas" id="Rutas">

                <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">
                        { tituloSeccion }
                    </h2>
                    
                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon">
                            <i className="fa-solid fa-person-walking"></i>
                        </div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row justify-content-center">
                        <p className='textoJustificado'>
                            { descricionSeccion }
                        </p>
                    </div>

                    {/* {
                        pintarTipoActividad()
                    }

                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span className='col-2'>
                                    <i className="fa-solid fa-person-walking"></i>
                                </span>
                                 Rutas Senderistas
                            </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">

                                <div className="btn-group mt-2 d-flex" role="group" aria-label="Basic radio toggle button group">
                                    <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" />
                                    <label className="btn btn-outline-danger" htmlFor="btnradio1">GR</label>

                                    <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" />
                                    <label className="btn btn-outline-warning" htmlFor="btnradio2">PR</label>

                                    <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off" />
                                    <label className="btn btn-outline-success" htmlFor="btnradio3">SL</label>
                                </div>
                                
                                <div className="row justify-content-center mt-4">

                                    <div className="col-md-6 col-lg-4 mb-5" key={1}>
                                        <div className="seccionBlanca-item mx-auto" data-bs-toggle="modal" data-bs-target={ '#act1' }>
                                            <div className="seccionBlanca-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                                <div className="seccionBlanca-item-caption-content text-center text-white">
                                                    <i className="fas fa-plus fa-3x"></i>
                                                </div>
                                            </div>
                                            <img className="img-fluid habitacion" src='img/act1.jpg' alt="test" />
                                            <p className='text-center fw-bolder mt-3'>Ruta 1</p>
                                        </div>
                                    </div>
                                                
                                </div>

                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <span className='col-2'>
                                    <i className="fa-solid fa-bicycle"></i>
                                </span>
                                Rutas Ciclistas
                            </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body">

                                    <div className="btn-group mt-2 d-flex" role="group" aria-label="Basic radio toggle button group">
                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" />
                                        <label className="btn btn-outline-danger" htmlFor="btnradio1">GR</label>

                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" />
                                        <label className="btn btn-outline-warning" htmlFor="btnradio2">PR</label>

                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off" />
                                        <label className="btn btn-outline-success" htmlFor="btnradio3">SL</label>
                                    </div>

                                    <div className="row justify-content-center mt-4">

                                        {
                                            pintarMapa()
                                        }
                                                
                                    </div>
                                    

                                </div>
                            </div>
                        </div>
                    </div> */}

                </div>

            </section>
        )
    }


  return (
    <>
        <Header nombreSeccion='RUTAS' />
        
        {
            generarSeccionRutas()
        }

        <Footer />
    </>
  )
}

export default Rutas